var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("view-nav", {
        attrs: { title: "Playlist management" },
        on: { nav: (w) => (this.week = w) },
        scopedSlots: _vm._u(
          [
            _vm.childRoute === "Playlists"
              ? {
                  key: "content",
                  fn: function ({ emit }) {
                    return [_c("weeks-nav", { on: { nav: emit } })]
                  },
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "view-content container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-2" }, [
            _c("ul", { staticClass: "box nav" }, [
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/playlists", "exact-path": "" },
                    },
                    [
                      _c("icon", {
                        staticClass: "red",
                        attrs: { name: "settings" },
                      }),
                      _vm._v(" Playlists\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/playlists/pings", "exact-path": "" },
                    },
                    [
                      _c("icon", {
                        staticClass: "red",
                        attrs: { name: "settings" },
                      }),
                      _vm._v(" Availability pings\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: "/playlists/confirmations",
                        "exact-path": "",
                      },
                    },
                    [
                      _c("icon", { attrs: { name: "settings" } }),
                      _vm._v(
                        " Reception confirmations\n                        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-content" },
                [
                  _vm.childRoute === "Playlists"
                    ? _c("heading", {
                        attrs: { upper: "Info", border: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "lower",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.infoMsg),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3152803258
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.childRoute === "PlaylistAvailablePings"
                    ? _c("heading", {
                        attrs: { upper: "Help", border: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "lower",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "Availability pings are sent by the playlist provider to notify Showtimes of new playlists to be downloaded."
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          214646793
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.childRoute === "PlaylistConfirmations"
                    ? _c("heading", {
                        attrs: { upper: "Help", border: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "lower",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "Playlist confirmations are sent by the exhibitor to inform the provider that playlists were well received and (partially) played."
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1223125203
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-10" },
            [
              _c("router-view", {
                attrs: { week: _vm.week },
                on: { stats: (s) => (_vm.stats = s) },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }